import Link from "next/link";
import * as C from "./cart-styles";
import { priceComma } from "../../common/splicePrice";
import SingleProduct from "../ecommerce/singleProduct/SingleProduct";
import RecomSlider from "./recomSlider";
import { Spinner } from "react-bootstrap";

const Cart = ({
  cartProducts,
  deleteAll,
  selectAllItems,
  selectedItem,
  selectItem,
  increaseBasketProduct,
  decreaseBasketProduct,
  isUser,
  decreaseCnt,
  increaseCnt,
  handleDelete,
  cartEstimate,
  onClickCheckout,
  naverpayCheckout,
  checkDeliveryPrice,
  price,
  deliveryPrice,
  nonCheckDelPrice,
  purchaseDirect,
  confirmItems,
  setSelectModal,
  relatedProducts,
  relatedLoading,
}) => {
  return (
    <>
      <C.CartSection>
        <div className="container">
          {cartProducts && cartProducts.length > 0 && (
            <C.CartBody>
              <C.CartHeader>
                <div className="d-flex all-check">
                  <div className="custome-checkbox">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={"all"}
                      onChange={(e) => selectAllItems(e)}
                      checked={selectedItem.includes(false) ? false : true}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="all"
                      style={{
                        textTransform: "capitalize",
                      }}
                    >
                      <span>모두선택</span>
                    </label>
                  </div>
                  <span className="ml-10">
                    {confirmItems?.length} / {cartProducts?.length}
                  </span>
                </div>
                <div className="d-flex delete">
                  <span onClick={() => deleteAll()}>전체 삭제</span>
                </div>
              </C.CartHeader>
              <C.CartMainWrapper>
                <C.CartListWrapper>
                  {cartProducts &&
                    cartProducts.map((item, i) => (
                      <C.CartItem key={i}>
                        <div className="d-flex info">
                          <div className="custome-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`${item.pcode}`}
                              value={item.pcode ? item.pcode : ""}
                              onChange={selectItem(i, item)}
                              checked={selectedItem[i] === true ? true : false}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${item.pcode}`}
                              style={{
                                textTransform: "capitalize",
                              }}
                            />
                          </div>
                          <C.ItemInfo>
                            <div className="d-flex mb-10">
                              <C.ItemImg>
                                <Link
                                  href={`/products/${item.ename}/${item.pcode}`}
                                >
                                  <img
                                    src={item.main_image}
                                    style={{ cursor: "pointer" }}
                                  />
                                </Link>
                              </C.ItemImg>
                              <div className="d-flex flex-column w-100">
                                <h6 className="pname">
                                  <Link
                                    href={`/products/${item.ename}/${item.pcode}`}
                                  >
                                    <a>{item.pname}</a>
                                  </Link>
                                  <a
                                    onClick={(e) => handleDelete(item, i)}
                                    className="remove"
                                  >
                                    <i className="fi-rs-trash"></i>
                                  </a>
                                </h6>
                                <div className="deliveryInfo">
                                  <span>
                                    {item.delivery_type_korea === "무료" ||
                                    item.delivery_type_korea === "착불" ? (
                                      <>{`${item.delivery_type_korea}배송`}</>
                                    ) : (
                                      <>
                                        {item.delivery_type_korea +
                                          " " +
                                          priceComma(item?.delivery_price) +
                                          "원"}
                                      </>
                                    )}
                                  </span>
                                  <span className="divide">|</span>
                                  <span>
                                    {item.deadline > 0 && (
                                      <>
                                        {item.deadline}시까지 주문시 당일 발송
                                      </>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <C.ItemPrice>
                              <div className="option">
                                <>
                                  <span>
                                    단가 :
                                    {" " +
                                      priceComma(
                                        Math.round(
                                          Number(item.discount_price) /
                                            Number(item.quantity)
                                        )
                                      )}
                                    원
                                  </span>{" "}
                                </>
                                <>
                                  / <span>묶음수량 : {item.quantity}개</span>
                                </>
                                {!(
                                  item.horizontal == 0 &&
                                  item.vertical == 0 &&
                                  item.height == 0
                                ) && (
                                  <>
                                    /{" "}
                                    <span>
                                      사이즈 :{" "}
                                      {(item.horizontal != 0
                                        ? item.horizontal
                                        : "-") +
                                        (item.vertical != 0
                                          ? "X" + item.vertical
                                          : "") +
                                        (item.height != 0
                                          ? "X" + item.height
                                          : "")}
                                    </span>
                                  </>
                                )}
                                {item.golgi && (
                                  <>
                                    / <span>골지 : {item.golgi}</span>
                                  </>
                                )}
                                {item.strength && (
                                  <>
                                    / <span>강도 : {item.strength}</span>
                                  </>
                                )}
                                {item.feature && (
                                  <>
                                    / <span>{item.feature}</span>
                                  </>
                                )}
                              </div>
                              <div className="cntPrice">
                                <div className="cnt">
                                  <i
                                    className="fi-rs-minus-small mr-10"
                                    onClick={(e) =>
                                      isUser
                                        ? decreaseBasketProduct(item)
                                        : decreaseCnt(item.pcode)
                                    }
                                  />
                                  <span>{item.cnt}</span>
                                  <i
                                    className="fi-rs-plus-small ml-10"
                                    onClick={(e) =>
                                      isUser
                                        ? increaseBasketProduct(item)
                                        : increaseCnt(item.pcode)
                                    }
                                  />
                                </div>
                                <h6 className="price">
                                  {priceComma(
                                    Number(item.discount_price) *
                                      Number(item.cnt)
                                  )}
                                  원
                                </h6>
                              </div>
                            </C.ItemPrice>
                            <span
                              className="direct"
                              onClick={purchaseDirect(item)}
                            >
                              개별 바로 구매
                            </span>
                          </C.ItemInfo>
                        </div>
                        <div className="delivery_price">
                          배송료: {checkDeliveryPrice(item)}
                        </div>
                      </C.CartItem>
                    ))}
                </C.CartListWrapper>
                {/* 모바일 요약부분 */}
                <C.MobileCartSummary>
                  <C.CartStickyInner>
                    <ul>
                      <li>
                        <span>총 상품금액</span>
                        <span>{priceComma(price()) + "원"}</span>
                      </li>
                      <li>
                        <span>총 배송비</span>
                        <span>
                          {"+" + priceComma(nonCheckDelPrice()) + "원"}
                        </span>
                      </li>
                      {deliveryPrice() - nonCheckDelPrice() !== 0 && (
                        <li
                          className={
                            deliveryPrice() - nonCheckDelPrice() < 0
                              ? "text-danger"
                              : ""
                          }
                        >
                          <span>
                            {deliveryPrice() - nonCheckDelPrice() < 0 &&
                              "묶음 배송 할인"}
                          </span>
                          <span>
                            {priceComma(deliveryPrice() - nonCheckDelPrice())}원
                          </span>
                        </li>
                      )}
                      <li>
                        <span>예상 결제금액</span>
                        <span>{priceComma(price() + deliveryPrice())}원</span>
                      </li>
                    </ul>
                    <span className="info">
                      * 최종 결제 금액은 도서산간 할증, 쿠폰 사용 등으로 인해
                      변동될 수 있습니다.
                    </span>
                  </C.CartStickyInner>
                </C.MobileCartSummary>
                <C.RecommendedWrapper>
                  <h6 className="title">이런 상품은 안필요하세요?</h6>
                  {relatedLoading && (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "300px" }}
                    >
                      <Spinner />
                    </div>
                  )}
                  {!relatedLoading && relatedProducts && (
                    <RecomSlider relatedProducts={relatedProducts} />
                  )}
                </C.RecommendedWrapper>
              </C.CartMainWrapper>
              <C.CartSummaryWrapper>
                <C.CartStickyWrapper id="sticky" className="sticky">
                  <C.CartStickyInner>
                    <ul>
                      <li>
                        <span>총 상품금액</span>
                        <span>{priceComma(price()) + "원"}</span>
                      </li>
                      <li>
                        <span>총 배송비</span>
                        <span>
                          {"+" + priceComma(nonCheckDelPrice()) + "원"}
                        </span>
                      </li>
                      {deliveryPrice() - nonCheckDelPrice() !== 0 && (
                        <li
                          className={
                            deliveryPrice() - nonCheckDelPrice() < 0
                              ? "text-danger"
                              : ""
                          }
                        >
                          <span>
                            {deliveryPrice() - nonCheckDelPrice() < 0 &&
                              "묶음 배송 할인"}
                          </span>
                          <span>
                            {priceComma(deliveryPrice() - nonCheckDelPrice())}원
                          </span>
                        </li>
                      )}
                      <li>
                        <span>예상 결제금액</span>
                        <span>{priceComma(price() + deliveryPrice())}원</span>
                      </li>
                    </ul>
                    <span className="info">
                      * 최종 결제 금액은 도서산간 할증, 쿠폰 사용 등으로 인해
                      변동될 수 있습니다.
                    </span>
                  </C.CartStickyInner>
                  <C.BtnWrapper>
                    <div className="btns">
                      <div className="basic_btns">
                        <Link href="/products/No-Tape-Box/">
                          <a className="btn border_btn">쇼핑 계속하기</a>
                        </Link>{" "}
                        <>
                          <div
                            className="naver-btn"
                            onClick={() => setSelectModal(true)}
                          >
                            <img
                              src="/assets/imgs/product/payment_icon_naver.png"
                              alt="네이버페이 구매"
                            />
                            구매
                          </div>
                        </>
                      </div>
                      <a
                        className="btn estimate"
                        onClick={() => cartEstimate()}
                      >
                        견적서 다운로드
                      </a>
                      <a onClick={onClickCheckout} className="btn">
                        {confirmItems?.length}개 구매하기
                      </a>
                    </div>
                  </C.BtnWrapper>
                </C.CartStickyWrapper>
              </C.CartSummaryWrapper>
            </C.CartBody>
          )}
          {cartProducts && cartProducts.length === 0 && (
            <C.EmptyWrapper>
              <img
                src="https://file.caretbio.com/caretbio/45e80cfaa7288992d1f6826ebd3db173.png"
                alt="empty-cart"
              />
              <h4 className="title">장바구니에 담긴 상품이 없습니다.</h4>
              <div>
                <Link href="/products/No-Tape-Box/">
                  <a className="btn">상품 담으러 가기</a>
                </Link>
              </div>
            </C.EmptyWrapper>
          )}
        </div>
        {/* 모바일 바텀 버튼 */}
        {cartProducts && cartProducts.length > 0 && (
          <C.MobileBtnSticky>
            <C.BtnWrapper>
              <div className="btns">
                <div className="basic_btns">
                  <a className="btn estimate" onClick={() => cartEstimate()}>
                    견적서 다운로드
                  </a>
                  <>
                    <div
                      className="naver-btn"
                      onClick={() => setSelectModal(true)}
                    >
                      <img
                        src="/assets/imgs/product/payment_icon_naver.png"
                        alt="네이버페이 구매"
                      />
                      구매
                    </div>
                  </>
                </div>
                <a onClick={onClickCheckout} className="btn">
                  {confirmItems?.length}개 결제하기
                </a>
              </div>
            </C.BtnWrapper>
          </C.MobileBtnSticky>
        )}
      </C.CartSection>
    </>
  );
};

export default Cart;
